// extracted by mini-css-extract-plugin
module.exports = {"packContainer":"styles_packContainer__2dsYQ","banner":"styles_banner__3oubf","cardContainer":"styles_cardContainer__aD5uX"};